import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import styled from 'styled-components'

import Tooltip from '@material-ui/core/Tooltip'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import SearchField from 'components/atoms/SearchField'
import SubmitButton from 'components/atoms/buttons/SubmitButton'
import CheckboxInput from 'components/molecules/CheckboxInput'

const styles = theme => ({
  root: { minWidth: 700 },
  body: {
    height: 250,
    overflowY: 'scroll',
    margin: `${theme.spacing(3)}px 0`,
    padding: `0 ${theme.spacing(3)}px`,
    borderTop: `1px solid ${theme.palette.background.medium} `,
    borderBottom: `1px solid ${theme.palette.background.medium} `,
  },
  header: {
    padding: `${theme.spacing(1)}px ${theme.spacing(3)}px 0 0`
  },
  footer: {
    height: 50,
  },
})

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  padding: 0 20px;
  max-width: 700px;
  height: 300px;
`

const ButtonContainer = styled.div`
  width: 360px;
  display: flex;
  justify-content: space-between; 
`

const StyledHelpIcon = styled(HelpOutlineIcon)`
  color: #AAAAAA;
  margin-left: 15px;
  margin-bottom: 5px;
  align-self: center;
  :hover {
    cursor: pointer;
  }
`

const TitleContainer = styled.div`
  display: flex;
`

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className, tooltip: 'tooltip' }}
    {...props}
  />
))`
  & .tooltip {
    width: 225px;
    font-size: 14px;
    opacity: 0.9;
    text-align: 'center';
    padding: 16px;
    background-color: #001325;  
  }
`

const BodyText = styled(Typography).attrs({ variant: 'h4' })`
  margin-bottom: 25px;
`

const TransferTrapsPopover = ({
  organisations,
  classes,
  onOrganisationSelect,
  selectedOrganisation,
  onConfirmClick,
  organisation,
}) => {
  const [isConfirmState, setIsConfirmState] = useState(false)
  const toggleConfirmState = () => setIsConfirmState(!isConfirmState)
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const [searchState, setSearchState] = useState('')
  
  return (
    <div className={classes.root}>
      {!isConfirmState ? 
        <React.Fragment>
          <TitleContainer>
            <Typography variant="h1" gutterBottom>Transfer to another project</Typography>
            <StyledTooltip
              placement="bottom"
              arrow
              enterDelay={500}
              title="You must be an admin in another project to be able to transfer traps to that project."
              open={tooltipOpen}
              onOpen={() => setTooltipOpen(true)}
              onClose={() => setTooltipOpen(false)} >
              <StyledHelpIcon />
            </StyledTooltip>
          </TitleContainer>
          <Grid
            container
            justify="space-between"
            alignItems="center"
            className={classes.header}>
            <SearchField onChange={val => setSearchState(val)} width={300} />
          </Grid>
          <section className={classes.body}>
            {organisations && !!Object.keys(organisations).length && (
              Object.keys(organisations).map((organisationId) => {
                const org = organisations[organisationId]
                const isActive = !!selectedOrganisation && selectedOrganisation.uuid === org.uuid
                if (searchState && org.name.toLowerCase().includes(searchState)) {
                  return org.uuid !== organisation.uuid && (
                    <CheckboxInput
                      key={org.uuid}
                      value={org.uuid}
                      onClick={onOrganisationSelect}
                      active={isActive}
                      text={org.name}
                      image={org.imageUrl}
                      isPopover
                    />
                  )
                }
                return org.uuid !== organisation.uuid && !searchState && (
                  <CheckboxInput
                    key={org.uuid}
                    value={org.uuid}
                    onClick={onOrganisationSelect}
                    active={isActive}
                    text={org.name}
                    image={org.imageUrl}
                    isPopover
                  />
                )
              })
            )}
          </section>
          <Grid
            container
            justify="flex-end"
            alignItems="center"
            className={classes.footer}>
            <SubmitButton
              size="medium"
              loading={false}
              color="primary"
              variant="primary"
              onClick={toggleConfirmState}
              disabled={!selectedOrganisation}>
               Transfer
            </SubmitButton>
          </Grid>
        </React.Fragment> :
        <React.Fragment>
          <TextContainer>
            <Typography variant="h1" gutterBottom>Transfer to another project</Typography>
            <BodyText>
             When you hit transfer, the data collected from these traps will be archived and retained within {organisation.name}.
            The trap will be transferred to {selectedOrganisation.name} and will appear as an unassigned trap with no data.  
            </BodyText>
            <Typography variant="subtitle2" gutterBottom>
            Note: The trap name and location will be pulled through and this can be changed in the new project, either through the dashboard or through the app. 
            </Typography>
          </TextContainer>
          <Grid
            container
            justify="center"
            alignItems="center"
            className={classes.footer}>
            <ButtonContainer>
              <SubmitButton
                size="medium"
                loading={false}
                color="primary"
                variant="secondary"
                onClick={toggleConfirmState}>
                Cancel
              </SubmitButton>
              <SubmitButton
                size="medium"
                loading={false}
                color="primary"
                variant="primary"
                onClick={onConfirmClick}
                disabled={!selectedOrganisation}>
                Transfer
              </SubmitButton>
            </ButtonContainer>
          </Grid>
        </React.Fragment>}
    </div>
  ) 
}

TransferTrapsPopover.propTypes = {
  organisations: PropTypes.object,
  classes: PropTypes.object,
  onOrganisationSelect: PropTypes.func,
  onConfirmClick: PropTypes.func,
  selectedOrganisation: PropTypes.object,
  organisation: PropTypes.object,
}

export default withStyles(styles)(TransferTrapsPopover)



// WEBPACK FOOTER //
// ./src/components/organisms/TransferTrapsPopover/TransferTrapsPopover.js